<template>
  <div class="product-template __donate  __limited-edu __uob-2023 __uob-2023--default __uob-primary">
    <div class="container pd-sm-0">
      <div class="col-md-push-1 col-md-10">
        <div class="text-center mb-10">
          <img src="/static/img/uob/logo-uob@2x.png" srcset="/static/img/uob/logo-uob@2x.png" alt="UOB" style="width: 150px" class="logo ma-auto d-block" />
          <img src="/static/img/uob/UOB-25-Anniversary-Logo_Final.png" srcset="/static/img/uob/UOB-25-Anniversary-Logo_Final.png" alt="UOB" style="width: 150px" class="logo ma-auto d-block" />
         
          <h1 class="page-title text-center">For 25 Years and Beyond</h1>
        </div>
        <h3 class="text-center mb-20 pb-20">Celebrating not only past success but building a brighter future together</h3>
    </div>
    </div>
    <div class="container pd-sm-0">
      <div class="col-md-push-2 col-md-8 col-lg-push-2 ">
        <div class="product product--inline">
          <div class="product__block--form">
            <div class="radius block shadow">
              <product-donate-choice
              :show-donate-type="true"
              :product="product"
              v-model="product.price"
              ref="donateChoice"
              classes="col-1-5" />
              <page-selector
                :product="product"
                v-model="attributes.page"
                v-show="false" />

              <product-cart-action
                :product="product"
                :attributes="attributes"
                :initialQuantity="1"
                :addToCartButton="false"
                :buyNowButton="false"
                :style="{margin:0}"
                ref="cartAction" />
              <div class="text-center _pt-20">
                <button type="button" class="btn btn--purple btn--default" @click.prevent="donate">บริจาค</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DonorInfo from '@/components/DonorInfo'
  import PageSelector from '@/components/PageSelector'
  import ProductCartAction from '@/components/ProductCartAction'
  import ProductDonateChoice from '@/components/ProductDonateChoice'
  export default {
    name: 'uob lovestory',

    components: {
      DonorInfo,
      PageSelector,
      ProductCartAction,
      ProductDonateChoice
    },

    props: {
      title: { type: String, default: 'บริจาค' },
      product: { type: Object, required: true }
    },

    data () {
      return {
        attributes: {
          info: {
            name: ''
          }
        }
      }
    },

    methods: {
      donate () {
        if (!this.$refs.donateChoice.validate()) {
          return
        }

        this.$store.dispatch('clearCart').then(() => {
          this.$refs.cartAction.buyNow()
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  h1.page-title {
    color: #005eb8;
    font-size: 2em;
    font-weight: 500;
    margin-bottom: 15px;
  }
  h3 {
    color:#005eb8;
  }
  .text-primary {
    color: #005eb8;
  }
  .block { background: #fff; }
  .btn--default {
    margin: 20px auto 10px;
  }

  .__uob-primary .btn--default {
    background: #005eb8 !important;
    border-color: #005eb8;
    margin-top: 40px;
  }
  
</style>



// WEBPACK FOOTER //
// uob-25thanniversary-foodforgood-2024.vue?57e83575